import React, { FC } from 'react';

import ReportsTableBlock from './blocks/reports-table.block';
import ReportHeaderBlock from './blocks/report-header.block';

const ReportsPage: FC<{ currentTemplate: 'chat' | 'voice' }> = ({ currentTemplate }) => {
  return (
    <div className={'pb-[35px]'}>
      <ReportHeaderBlock currentTemplate={currentTemplate} />
      <ReportsTableBlock currentTemplate={currentTemplate} />
    </div>
  );
};

export default ReportsPage;
